import en from './locales/en.json';
import ptBR from './locales/pt-BR.json';
import es from './locales/es.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

export const LOCALES = ['en', 'pt-BR', 'es', 'de', 'fr'];

const catalogs = {
  en,
  'pt-BR': ptBR,
  es,
  de,
  fr,
};

function normalizeLocale(raw) {
  if (!raw || typeof raw !== 'string') return 'en';
  const lower = raw.trim();
  if (LOCALES.includes(lower)) return lower;
  const base = lower.split('-')[0].toLowerCase();
  if (base === 'pt') return 'pt-BR';
  if (LOCALES.includes(base)) return base;
  return 'en';
}

function detectLocale() {
  if (typeof navigator !== 'undefined' && navigator.language) {
    return normalizeLocale(navigator.language);
  }
  return 'en';
}

// Product ships pt-BR by default (matches existing UI + tests). Call
// `initLocaleFromNavigator()` from the app shell to honor the browser.
let locale = 'pt-BR';

export function getLocale() {
  return locale;
}

export function setLocale(next) {
  locale = normalizeLocale(next);
  return locale;
}

export function initLocaleFromNavigator() {
  locale = detectLocale();
  return locale;
}

/**
 * Translate a key. Optional `{name}` placeholders via vars.
 * Falls back to English, then to the key itself.
 */
export function t(key, vars = {}) {
  const dict = catalogs[locale] || catalogs.en;
  let s = dict[key] ?? catalogs.en[key] ?? key;
  if (vars && typeof vars === 'object') {
    s = String(s).replace(/\{(\w+)\}/g, (_, name) =>
      vars[name] != null ? String(vars[name]) : `{${name}}`,
    );
  }
  return s;
}

export default { t, getLocale, setLocale, LOCALES };
